import { render, staticRenderFns } from "./dialog-previewpublic.vue?vue&type=template&id=abb61674&scoped=true&"
import script from "./dialog-previewpublic.vue?vue&type=script&lang=js&"
export * from "./dialog-previewpublic.vue?vue&type=script&lang=js&"
import style0 from "./dialog-previewpublic.vue?vue&type=style&index=0&id=abb61674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb61674",
  null
  
)

export default component.exports